import 'shared/pages/AssistanceSubmittedPage/styles.scss';


function AssistanceSubmittedPage() {
    return <div className={"AssistanceSubmittedPage"}>
        <h1>Your information was submitted!</h1>
        <p>A Financial Professional will be in touch within 1 business day to review and discuss your options.</p>
    </div>;
}

export default AssistanceSubmittedPage;
